<template>
  <div class="component-score-box">
    <!-- //  1 表示填空题，2 表示客观题，3 表示解答题，4表示英文作文，5表示语文作文，6表示选做题 -->
    <!-- 解答题不需要留白 后来改为所有题型不需要题号高度留白 -->
    <span v-if="msg.hasTitle" :title="msg.name">
      {{
        `${msg.th}、${msg.name && msg.name.substr(0, 38)}${
          msg.name && msg.name.length > 38 ? "..." : ""
        }`
      }}  
      <span class="score" v-if="!answerSheet.acCardHideScore"
        >（{{
          parseInt(msg.totalScore) == msg.totalScore
            ? msg.totalScore
            : (String(msg.totalScore.toFixed(1)).split(".")[1] == "0"
                ? String(msg.totalScore.toFixed(1)).split(".")[0]
                : msg.totalScore.toFixed(1)) || 2
        }}分）</span
      >
    </span>
    <span v-else></span>
    <div
      v-if="answerSheet.acCardYJType == 0 && msg.type != 2 && !msg.isSub"
      class="score-box"
      :style="`top:${msg.hasTitle ? '41px' : '.5px'}`"
    >
      <div class="s-text">
        得
        <br />分
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
export default {
  props: ["msg"],
  computed: {
    ...mapState("answerPanel", {
      answerSheet: (state) => state.answerSheet,
    }),
  },
  watch: {
    msg: {
      handler(newVal) {
        // console.log("我来看看1", newVal);
      },
      deep: true,
    },
  },
};
</script>

<style lang='scss' scoped>
.component-score-box {
  position: relative;
}
.score-box {
  position: absolute;
  display: flex;
  right: 1px;
  top: 41px;
  width: 85px;
  height: 34px;
  box-sizing: border-box;
  border: 1px solid #000;
  z-index: 999;
  border-top: none;
  border-right: none;
  background: #fff;
  opacity: 0.8;
  font-size: 12px;
}
.score-box .s-text {
  padding: 0 3px;
  line-height: 16px;
  border-right: 1px solid #000;
}
</style>